export default {
    faqs (state) {
      return state.faqs
    },

    selectedFaq (state) {
        return state.selectedFaq
    },

    getFaq: state => (faqId) => {
      return state.faqs().find(faq => faq.faqId === faqiId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/faqs/getters.js